/* RESPONSIBLE TEAM: team-billing */

export default [
  'AU', // Australia
  'CA', // Canada
  'CH', // Switzerland
  'MY', // Malaysia
  'NO', // Norway
  'NZ', // New Zealand
];
